function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled186X186Px = function SvgFilled186X186Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 240.8 236.7",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m145.2 9.3 87.4 90.9c11.5 11.9 10.9 30.8-1.2 42.1l-92.5 86c-12.1 11.3-31.3 10.7-42.8-1.2l-87.4-91C-2.8 124.2-2.2 105.3 9.9 94l92.5-86c12.2-11.2 31.3-10.6 42.8 1.3",
    style: {
      fill: "#e2001a"
    }
  }));
};
export default SvgFilled186X186Px;